    import React, { Component } from 'react';
import { connect } from 'react-redux';

//3 party Libs
import moment from 'moment';

//material ui components
import { Grid } from '@material-ui/core'

//Actions
import { getCommunityByIdAsync } from '../../actions/communityActions'
import { GetAllActivities, GetActivityDetails, GetCalendarActivities, GetCategorieObject, GetMultipleCategorieObject } from '../../actions/activityAction';
import parse from 'html-react-parser';

export class SchedulerDailyView extends Component {
    constructor(props) {
        super();

        this.state = {
            referenceDay: new moment(),
            today: new moment(),
            steps: props.stepCount ? props.stepCount : 0,
            communityLoaded: (props.communitySelected) ? props.communitySelected : undefined,
            activitiesForToday: [],
        }
    }
    componentDidMount() {
        try { } catch (err) { }
    }


    //#region Methods
    GetHTMLFromString = ({ str = undefined, styleObjString = undefined }) => {
        try {
            let newStr = str;
            if (styleObjString && styleObjString.length > 0) {
                newStr = this.ChangeStrStyle(str, styleObjString);
            }

            if (!newStr) return (<Grid item container></Grid>)

            return (
                <Grid item container>
                    {parse(newStr)}
                </Grid>
            )
        } catch (err) {
            return (<Grid item container></Grid>)
        }
    }

    ChangeStrStyle = (str, styleObj) => {
        try {
            let strModified = str;
            const styleObjAsString = `<svg ${styleObj} `

            if (styleObj) {
                strModified = str.replace('<svg', styleObjAsString);
            }

            return strModified
        } catch (err) {
            return str;
        }
    }

    async GetActivities() {
        const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;

        this.setState({ Activities: null })
        let activities = await this.props.GetCalendarActivities(communityId);

        activities = this.props.activitiesData.map(item => ({
            ...item,
            date: new Date(new Date(item.date).toLocaleString("en-US", { timeZone: this.props.communitySelected.timeZoneName })),
            endDate: new Date(new Date(item.endDate).toLocaleString("en-US", { timeZone: this.props.communitySelected.timeZoneName })),
        }));//End map

        const startDate = this.state.today ? this.state.today.clone().startOf('day') : undefined;
        const endDate = this.state.today ? this.state.today.clone().endOf('day') : undefined;
        const dayActivities = activities.filter(activity => moment(activity.date) >= startDate && moment(activity.date) <= endDate)

        const currentDayActivities = {
            currentDayActivities: dayActivities,
            currentDayName: this.state.today,
        }

        let activityNamesToFilter = [...new Set(activities.map(item => item.title))];
        if (activityNamesToFilter) {
            activityNamesToFilter = activityNamesToFilter.map((item, index) => ({ id: index + 1, name: item }))
        }

        this.GetMaximunNumberOfActivitiesPerDay(startDate, endDate, dayActivities);


        this.setState({ AllActivities: activities, Activities: activities, currentDayActivities: currentDayActivities })
    };

    filterActivities = (activities, filterObject) => {

        const baseActivities = [...activities];
        let newActivities = undefined;
        newActivities = baseActivities;

        //Activity Search
        if (filterObject.searchInput) {
            const regex = new RegExp(filterObject.searchInput.toLowerCase());
            newActivities = newActivities.filter(item => item.title.toLowerCase().match(regex));
        }

        if (filterObject) {
            //Activities Filter
            if (filterObject.activityFilter) {
                newActivities = newActivities.filter(item => item.title.trim() === filterObject.activityFilter.trim());
            }

            //Category Filter


            if (filterObject.categoryFilter) {

                newActivities = newActivities.filter(item => item.category.name.trim() === filterObject.categoryFilter.trim());
            }
        }

        this.setState({
            filteredActivities: newActivities
        });
    };


    InitialLoading = async () => {
        try {
            if (this.props.updateIsNeeded) {
                this.GetActivities();
                this.props.setUpdateIsNeeded(false);
            }


            let steps = 0;
            let today = new moment();
            if (this.props.stepCount && (this.props.stepCount !== this.state.step)) {
                today = (this.state.referenceDay) ? new moment(this.state.referenceDay).clone().add(this.props.stepCount, 'd') : undefined;
                steps = this.props.stepCount;
            }

            let activitiesForToday = undefined;
            let categoriesForToday = undefined;
            let locationsForToday = undefined;



            let filteredActivities = (this.state.filteredActivities && this.state.filteredActivities.length)? this.state.filteredActivities : this.props.activitiesData;

            if ((this.props.filterObj !== this.state.filterObj) && (this.props.activitiesData && this.props.activitiesData.length > 0)) {
                this.setState({ filterObj: this.props.filterObj ? this.props.filterObj : {} },
                    () =>{
                        this.filterActivities(this.props.activitiesData, this.props.filterObj);     
                    });
            }


            if (filteredActivities && filteredActivities.length > 0) {
                activitiesForToday = await this.GetActivitiesForToday(filteredActivities, today)

            }

            if (activitiesForToday && activitiesForToday.length > 0) {
                activitiesForToday = activitiesForToday.map(item => {
                    return ({
                        ...item,
                        date: new Date(new Date(item.date).toLocaleString("en-US", { timeZone: this.props.communitySelected.timeZoneName })),
                        endDate: new Date(new Date(item.endDate).toLocaleString("en-US", { timeZone: this.props.communitySelected.timeZoneName })),
                    })
                });

            }

            if (activitiesForToday && activitiesForToday.length > 0) {
                categoriesForToday = await this.GetCategoriesForToday(activitiesForToday);
                locationsForToday = this.GetLocationsForToday(activitiesForToday);
            }

            let shouldEnter = true;
            if (
                shouldEnter &&
                (

                    (steps && steps !== this.state.steps) ||
                    (today && today.format('L') !== this.state.today.format('L')) ||
                    (activitiesForToday && activitiesForToday.length > 0 && this.state.activitiesForToday.length === 0) ||
                    (activitiesForToday && activitiesForToday.map(a => a._id).sort().join('') !== this.state.activitiesForToday.map(a => a._id).sort().join(''))
                )
            ) {
                shouldEnter = false;

                this.setState({ steps: steps, today: today, activitiesForToday: activitiesForToday, categoriesForToday: categoriesForToday, locationsForToday: locationsForToday }, () => { shouldEnter = true; });
            }

        } catch (err) { }
    }

    GetLocationsForToday = (activitiesForToday) => {
        try {
            if (!activitiesForToday) return undefined

            let locationsUniqueArray = [];
            for (let i = 0; i <= activitiesForToday.length; i++) {
                const currentLocation = (activitiesForToday[i] && activitiesForToday[i].location) ? activitiesForToday[i].location : undefined;

                if (!currentLocation) continue;

                let locationFound = locationsUniqueArray.find(loc => loc.toLowerCase() === currentLocation.toLowerCase());

                if (locationFound) continue;

                locationsUniqueArray.push(currentLocation);
            }

            locationsUniqueArray = locationsUniqueArray.sort();

            let LocationObjArray = [];
            for (let i = 0; i < locationsUniqueArray.length; i++) {
                const currentLocation = locationsUniqueArray[i];
                let locationSplitArray = currentLocation.split(/[\s+]/);
                //Starts with number
                const regexNumber = new RegExp('^[0-9]+');

                const res = regexNumber.test(locationSplitArray[0]);
                let locationCode = undefined;

                if (locationSplitArray[0] && locationSplitArray[0].length > 0 && res) {
                    let letterArray = locationSplitArray[0].split('');
                    letterArray = letterArray.filter(l => regexNumber.test(l)).join('');
                    locationCode = (letterArray && letterArray.length > 1) ? letterArray.slice(0, 2) : letterArray;

                } else {
                    let locationFiltered = locationSplitArray.filter(l => (l !== '&' && l !== '&&') ? true : false)
                    locationFiltered = locationFiltered.map(l => l.slice(0, 1))

                    locationCode = (locationSplitArray && locationSplitArray.length === 1) ? locationFiltered[0] : locationFiltered[0] + locationFiltered[1]
                    const LocationObjFound = LocationObjArray.find(l => l.code.toUpperCase() === locationCode.toUpperCase());

                    if (LocationObjFound) {
                        let newCode = currentLocation.split('\\s+');
                        newCode = newCode.filter(l => (l !== '&' && l !== '&&'))
                        locationCode = newCode.map(w => {
                            let code = undefined;
                            if (w && w.length > 1) {
                                code = w.slice(0, 2);
                            } else {
                                code = w[0]
                            }

                            return code
                        }
                        ).join('').slice(0, 2);
                    }
                }

                const newLocation = {
                    code: locationCode,
                    name: currentLocation,
                }
                LocationObjArray.push(newLocation);


            }

            return LocationObjArray;
        } catch (err) {
            return undefined
        }
    }

    GetCategoriesForToday = async (activitiesForToday) => {
        try {
            if (!activitiesForToday) return undefined

            let categoriesUniqueArray = [];
            for (let i = 0; i <= activitiesForToday.length; i++) {
                const currentCategorieObj = (activitiesForToday[i] && activitiesForToday[i].category) ? activitiesForToday[i].category : undefined;

                if (!currentCategorieObj) continue;

                let newCategoryObj = {
                    name: (currentCategorieObj.name) ? currentCategorieObj.name : undefined,
                    iconUrl: (currentCategorieObj.iconUrl) ? currentCategorieObj.iconUrl : undefined,
                    categoryColor: (currentCategorieObj.categoryColor) ? currentCategorieObj.categoryColor : undefined,
                    categoryId: (currentCategorieObj.categoryId) ? currentCategorieObj.categoryId : undefined,
                }

                let categoryObjFound = categoriesUniqueArray.find(cat => cat.name.toLowerCase() === newCategoryObj.name.toLowerCase());

                if (categoryObjFound) continue;

                categoriesUniqueArray.push(newCategoryObj);
            }

            categoriesUniqueArray = categoriesUniqueArray.sort((a, b) => a.name.toUpperCase() > b.name.toUpperCase());

            // for(let i =0; i< categoriesUniqueArray.length; i++){
            //     const currentCategorieObj = categoriesUniqueArray[i];

            //     if(!currentCategorieObj || !currentCategorieObj.iconUrl || !currentCategorieObj.categoryColor || ! currentCategorieObj.categoryId|| !this.props.GetCategorieObject) continue

            //     const catIconSVGObject = await this.props.GetCategorieObject(currentCategorieObj.iconUrl, currentCategorieObj.categoryColor, currentCategorieObj.categoryId);

            //     currentCategorieObj.svgString = (catIconSVGObject)? catIconSVGObject : undefined;
            // }

            let urlObjArray = [];
            const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;

            for (let i = 0; i < categoriesUniqueArray.length; i++) {
                const currentCategorieObj = categoriesUniqueArray[i];
                const newUrlObj = {
                    communityId: communityId,
                    categoryId: currentCategorieObj.categoryId,
                    categoryColor: currentCategorieObj.categoryColor,
                    defaultIconUrl: currentCategorieObj.iconUrl,
                }

                urlObjArray.push(newUrlObj);
            }

            let newUrlsArray = undefined;
            if (urlObjArray && urlObjArray.length > 0) {
                newUrlsArray = await this.props.GetMultipleCategorieObject(urlObjArray)
            }

            let newUrlsObjArray = [];
            if (newUrlsArray && newUrlsArray.length > 0) {
                newUrlsObjArray = JSON.parse(newUrlsArray);
            }

            for (let i = 0; i < newUrlsObjArray.length; i++) {
                const currentObj = newUrlsObjArray[i];


                const uniqueCategory = categoriesUniqueArray.find(cat => cat.categoryId === currentObj.categoryId && !cat.svgString);

                if (uniqueCategory && currentObj.svgObject) {
                    uniqueCategory.svgString = currentObj.svgObject;
                }
            }
            return categoriesUniqueArray;

        } catch (err) {
            return []
        }
    }


    GetActivitiesForToday = async (allActivities, today) => {
        try {
            if (!today || !allActivities) return undefined;

            const startOf = new moment(today).startOf('day');
            const endOf = new moment(today).endOf('day');
            const activitiesForToday = allActivities.filter(act => (new moment(act.date) >= startOf && new moment(act.date) <= endOf) ? true : false);

            if (!activitiesForToday) return false;

            const maxActivities = 12;
            const sliceActivities = (activitiesForToday && activitiesForToday.length > 12) ? activitiesForToday.slice(0, maxActivities) : activitiesForToday;

            return sliceActivities;
        } catch (err) { }
    }
    GetCategoryBadge(categoryName) {
        let categoryWords = categoryName.split(' ');

        categoryWords = categoryWords.filter(item => item !== '&');

        const CategoryBadge = categoryWords.map(word => word.charAt(0).toUpperCase()).join('').slice(0, 2);

        return CategoryBadge;
    };

    async GetActivityObject(locationActivityId) {


        this.setState({ activitySelected: null })

        const activityObject = await this.props.GetActivityDetails(locationActivityId, localStorage.getItem('communityId'));

        if (activityObject) {
            this.props.OnActivityClick(activityObject, 'activity_' + locationActivityId)
            //this.props.history.push({pathname:'/activities', state: activityObject})
        }
    };

    // GetSVG = () =>{
    //     const str='<svg fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M631.98 64h-96.92l-.24-.3c5.39-9.45 8.38-20.32 8.38-31.7 0-17.67-14.33-32-32-32H400c-69.18 0-125.38 55.26-127.59 123.92-35.69-9.21-63.11-34.71-81.51-76.61-4-9.16-13.06-15.16-23.03-15.31-10.53.2-18.84 5.36-23.13 14.39C133.63 69.94 128 95.08 128 121.09c0 75.38 56.56 143.6 132.87 161.9 4.42 1.06 8.86-1.96 9.7-6.43l2.97-15.7c.8-4.22-1.93-8.17-6.1-9.2C205.69 236.47 160 181.6 160 121.09c0-16.31 2.72-32.19 8.06-47.38C197.38 130.23 244.1 160 303.94 160l.06-32c0-53.02 42.98-96 96-96h111.2c0 13.29-8.1 24.66-19.63 29.5l20.39 24.78.05 93.88a16 16 0 0 1-10.83 15.15l-25.52 8.71c-9.33 3.19-16.14-2.76-18.48-6.27L432 160l-48-16v100.21c0 26.67-12.65 50.17-32 65.6V480h-64V318.69l-104.43-23.21-32.12 89.47L175.53 480H118l-21.13-87.86a31.698 31.698 0 0 1 .37-16.18l27.63-93.41C107.46 270.37 96 250.24 96 227.37c0-15.82 5.68-30.18 14.82-41.68-4.94-10.84-8.98-22.04-11.4-33.73-8.09 6.94-15.19 15.02-20.76 24.18C35.11 176.87 0 212.27 0 256v56c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-56c0-21.5 14.23-39.48 33.72-45.59-.96 5.54-1.71 11.15-1.71 16.96 0 24.2 8.9 47.33 24.53 65.24l-21.97 74.27c-3.12 10.77-3.38 22.03-.8 32.74l21.13 87.86C90.34 501.86 103.21 512 118 512h57.53c20.95 0 36.12-19.75 31.02-39.86l-21.68-85.57 19.29-53.73L256 344.36V480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V323.8c20.5-21.5 32-49.75 32-79.59v-50.52l14.55 21.82c19.11 28.67 49.98 20.67 55.45 18.8l25.52-8.71c19.44-6.63 32.5-24.89 32.49-45.44l-.03-64.83 92.45-36.66c6.58-4.4 3.47-14.67-4.45-14.67zM464.01 96c0-8.84-7.16-16-16-16s-16 7.16-16 16 7.16 16 16 16c8.83 0 16-7.16 16-16z"/></svg> '    

    //     const grid = document.getElementById('testSVG');
    //     grid.setAttribute('background-color','red')
    //     return undefined
    // }

    //#endregion Methods

    //#region JSX Components
    RenderHeader = ({ today }) => {

        const month = today.format('MMMM');
        const dayOrdinal = today.format('Do');
        const day = today.format('D')
        const year = today.format('YYYY');

        let DateStringHeader = (month && dayOrdinal && year) ?
            <Grid item container alignContent='center' className='DayViewDate'>
                <Grid item >
                    <grid className='DayViewDateStrong'>
                        {`${month} ${day},`}
                    </grid>
                </Grid>
                <Grid item>
                    &nbsp;
                    {year}
                </Grid>
            </Grid>
            :
            undefined

        return (
            <Grid item container xs={12} className='DayViewHeader' alignContent='flex-end'>
                <Grid item container xs={7} alignContent='flex-end' justify='flex-start' >
                    <Grid item>
                        {DateStringHeader}
                    </Grid>
                </Grid>
                <Grid item container xs={5} alignContent='center' justify='flex-end'>
                    <Grid item className='DayViewCommuntyImg'>
                        {
                            (this.state.communityLoaded && this.state.communityLoaded.communityLogoUrl) ?

                                <img
                                    className='DayViewCommuntyImg'
                                    src={this.state.communityLoaded.communityLogoUrl}
                                    alt={this.state.communityLoaded.name}
                                />
                                :
                                undefined
                        }
                    </Grid>
                </Grid>
            </Grid>
        )
    };

    RenderContent = ({ today, activities, uniqueCategories = undefined, uniqueLocations = undefined }) => {
        try {

            if (!activities) return <Grid item container></Grid>

            return (
                <Grid item container xs={12} >
                    <Grid item container xs={7} className='DailyViewActivitiesContainer' alignContent='flex-start' style={{ border: '1px solid #009EDD' }}>
                        <this.RenderActivitiesContainer today={today ? today : undefined} activities={activities ? activities : undefined} />
                    </Grid>
                    <Grid item container xs={5} className='oddRow' alignContent='flex-start' style={{ border: '1px solid #009EDD' }}>
                        <this.RenderCategoriesContainer categoriesForToday={this.state.categoriesForToday ? this.state.categoriesForToday : undefined} stylesContainer={{ borderBottom: '1px solid #009EDD' }} />
                        <this.RenderLocationsContainer locationsForToday={this.state.locationsForToday ? this.state.locationsForToday : undefined} stylesContainer={{}} />
                    </Grid>
                </Grid>
            )
        } catch (err) { }

    }

    RenderActivitiesContainer = ({ today, activities }) => {
        try {
            if (!today) return (<Grid item container></Grid>)

            return (
                <Grid item container xs={12} className='ScheduleDailyText'>
                    <Grid item container xs={12} className='scheduleDailyBanner' justify='center' alignContent='center'>
                        <Grid item >{today.format('dddd').toUpperCase()}</Grid>
                    </Grid>
                    <Grid item container xs={12} style={{ padding: '26px 0px' }}>
                        {
                            activities ?
                                activities.map(a => {
                                    const locationCodeFound = (a && a.location && this.state.locationsForToday) ? this.state.locationsForToday.find(l => l.name.toLowerCase() === a.location.toLowerCase()) : undefined;
                                    const locationCode = (locationCodeFound && locationCodeFound.code) ? locationCodeFound.code : undefined;

                                    let activityTitle = (a.title && a.title.length > 50) ? a.title.slice(0, 47).trim() + `...` : a.title.trim();
                                    activityTitle = activityTitle + ` (${locationCode.toUpperCase()})`
                                    const isSpecialActivity = (a && a.category && a.category.name && (a.category.name.toLowerCase() === 'special events' || a.category.name.toLowerCase() === 'special event'));

                                    const categoryFound = (this.state.categoriesForToday) ? this.state.categoriesForToday.find(cat => cat.name === a.category.name) : undefined;

                                    return (
                                        <Grid item container xs={12} className={isSpecialActivity ? 'scheduleDailyActivity activityTitleScheduleSpecialEvent' : 'scheduleDailyActivity'} onClick={() => this.GetActivityObject(a._id)}>
                                            <Grid item container xs={2}>
                                                <Grid item container xs={8} justify='flex-end' alignContent='flex-start'>
                                                    <Grid item style={{ paddingLeft: '10px' }}>{new moment(a.date).format('h:mm')}</Grid>
                                                </Grid>
                                                <Grid item container xs={4} justify='center' alignContent='flex-start' style={{ padding: '5px 0' }}>
                                                    {
                                                        (a && a.category) ?
                                                            <Grid item container justify='center' alignContent='center'>

                                                                {
                                                                    (categoryFound && categoryFound.svgString) ?
                                                                        <Grid item style={{ height: '15px', width: '15px' }} >
                                                                            <this.GetHTMLFromString str={categoryFound.svgString} styleObjString={"style='height: 15px; width: 15px;'"} />
                                                                        </Grid>
                                                                        :
                                                                        undefined
                                                                }
                                                            </Grid>
                                                            :
                                                            undefined
                                                    }
                                                </Grid>

                                            </Grid>
                                            <Grid item container xs={10} justify='flex-start' alignContent='center'>
                                                <Grid item id={'activity_' + a._id} key={'activity_' + a._id} style={{ paddingLeft: '7px' }}>
                                                    {activityTitle}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )
                                })
                                :
                                undefined
                        }
                    </Grid>
                </Grid>
            )
        } catch (err) { }
    }

    RenderCategoriesContainer = ({ categoriesForToday = undefined, stylesContainer = undefined }) => {
        try {

            if (!categoriesForToday || categoriesForToday.length === 0) return (<Grid item container></Grid>)


            const newCategoriesForToday = (categoriesForToday && categoriesForToday.length > 10) ? categoriesForToday.slice(0, 10) : categoriesForToday;

            return (
                <Grid item container className='DailyViewActivitiesKeyContainer' justify='center' alignContent='flex-start' style={{ ...stylesContainer, overflow: 'hidden' }}>
                    <Grid item className='DailyViewKeyTitle'>
                        Category Key
                    </Grid>
                    <Grid item container className='ScheduleDailyText' justify='center' alignContent='flex-start' style={{ paddingLeft: '10px', paddingTop: '5px' }}>
                        {
                            newCategoriesForToday.map(cat => {
                                const newCategoryName = (cat.name && cat.name.length > 20) ? cat.name.slice(0, 17) + '...' : cat.name;
                                return (
                                    <Grid item container style={{ padding: ' 5px 5px' }} justify='center' alignContent='center'>
                                        <Grid item container xs={1} style={{ padding: '5px 5px' }}>

                                            {
                                                (cat.name) ?
                                                    <Grid item container>
                                                        <Grid item>
                                                            {
                                                                (cat.svgString) ?
                                                                    // <Grid item container id='testSVG' style={{height:'14px', width:'14px'}} dangerouslySetInnerHTML={{__html: cat.svgString}}></Grid>
                                                                    <Grid item style={{ height: '15px', width: '15px' }} >
                                                                        <this.GetHTMLFromString str={cat.svgString} styleObjString={"style='height: 15px; width: 15px;'"} />
                                                                    </Grid>
                                                                    :
                                                                    undefined
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                    :
                                                    undefined

                                            }

                                        </Grid>
                                        <Grid item container xs={11} justify='flex-start' alignContent='flex-end' style={{ paddingLeft: '5px' }}>
                                            <Grid item>{newCategoryName}</Grid>
                                        </Grid>
                                    </Grid>
                                )
                            })
                        }

                    </Grid>
                </Grid>
            )
        } catch (err) {
            return (<Grid item container></Grid>)
        }
    }

    RenderLocationsContainer = ({ locationsForToday = undefined, stylesContainer = undefined }) => {

        if (!locationsForToday || locationsForToday.length === 0) return (<Grid item container></Grid>)

        const newLocationsForToday = (locationsForToday && locationsForToday.length > 10) ? locationsForToday.slice(0, 10) : locationsForToday;

        try {
            return (
                <Grid item container className='DailyViewActivitiesKeyContainer' justify='center' alignContent='flex-start' style={{ ...stylesContainer, overflow: 'hidden' }}>
                    <Grid item className='DailyViewKeyTitle'>
                        Location Key
                    </Grid>
                    {
                        newLocationsForToday.map(l => {
                            return (
                                <Grid item container className='ScheduleDailyText' justify='center' alignContent='flex-start' style={{ paddingLeft: '10px', paddingTop: '5px' }}>
                                    <Grid item container className='ScheduleDailyTextCode activityTitleScheduleSpecialEvent' xs={1} justify='flex-end' alignContent='flex-end' style={{ fontSize: '15px', fontcolor: 'black', padding: '0px 5px' }}>
                                        <Grid item>{l.code.toUpperCase()}</Grid>
                                    </Grid>
                                    <Grid item container xs={11} className='dailyviewLocationStyles' alignContent='flex-end' justify='flex-start' style={{ paddingLeft: '5px' }}>
                                        <Grid item >{l.name}</Grid>
                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            )
        } catch (err) {
            return (<Grid item container></Grid>)
        }
    }
    //#endregion JSX Components



    render() {
        this.InitialLoading();

        // this.GetSVG()

        return (
            <Grid container justify='center'>
                <Grid item container className='schedulerSizePortrait' justify='center' id={this.props.idToSet ? this.props.idToSet : undefined}>
                    <Grid item container xs={12} >
                        <this.RenderHeader today={this.state.today ? this.state.today : new moment()} />
                    </Grid>
                    <Grid item container xs={12}>
                        <this.RenderContent today={this.state.today ? this.state.today : undefined} activities={(this.state.activitiesForToday) ? this.state.activitiesForToday : undefined} />
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

function mapStateToProps(state) {

    let activitiesData = (state.activityReducer && state.activityReducer.calendarActivityData) ? state.activityReducer.calendarActivityData : [];

    activitiesData = activitiesData.sort((a, b) => {
        return (new moment(a.date) > new moment(b.date)) ? 1 : -1
    })

    return {
        activitiesData: activitiesData,
    };
};


export default connect(mapStateToProps, { getCommunityByIdAsync, GetAllActivities, GetActivityDetails, GetCalendarActivities, GetCategorieObject, GetMultipleCategorieObject })(SchedulerDailyView)